





























import { computed, defineComponent, ref } from '@vue/composition-api';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import { useReassign } from '@/store/modules/reassign';
import { useAllResources } from '@/store/modules/resources';
import { Group } from '@/store/types';

export default defineComponent({
	components: { ConfirmDialog },
	inheritAttrs: false,
	props: {
		fieldIds: {
			required: true,
			type: Array as () => string[],
		},
		groups: {
			required: true,
			type: Array as () => Group[],
		},
	},
	setup(props, { root }) {
		const selectedGroup = ref(null);
		const showConfirmationDialog = ref(false);
		const { reassignField, clearError, isLoading, hasError } = useReassign(root.$store);
		const {
			isLoading: resourcesAreLoading,
			isLoaded: resourcesAreLoaded,
			hasError: resourcesHaveError,
			fields,
		} = useAllResources(root.$store);
		const selectedFields = computed(() =>
			resourcesAreLoaded.value
				? props.fieldIds.map((fieldId) => root.$store.getters['resources/getFieldById'](fieldId))
				: []
		);
		const fieldGroups = computed(() => selectedFields.value.map((field) => field.meta.groupId));
		const groupOptions = computed(() =>
			new Set(fieldGroups.value).size === 1
				? props.groups.filter((group) => group.id !== fieldGroups.value[0])
				: props.groups
		);
		const title = computed(() =>
			resourcesAreLoaded && selectedFields.value.length === 1
				? `Move ${selectedFields.value[0].name} to Group`
				: `Move ${selectedFields.value.length} Fields to Group`
		);
		const buttonText = computed(() => (props.fieldIds.length <= 1 ? 'Move' : `Move (${selectedFields.value.length})`));
		const noGroupsText = computed(
			() =>
				`You lack permission to move ${props.fieldIds.length <= 1 ? 'this field' : 'these fields'} to another group.`
		);

		return {
			handleConfirmReassign: async () => {
				clearError();

				const success = await reassignField({
					groupId: selectedGroup.value ?? '',
					fieldId: props.fieldIds,
				});

				if (success) {
					root.$store.dispatch('resources/getAllResources');
					showConfirmationDialog.value = false;
				}
			},
			clearError,
			showConfirmationDialog,
			selectedGroup,
			groupOptions,
			isLoading,
			hasError,
			title,
			buttonText,
			noGroupsText,
		};
	},
});
